import React from "react";
import ThankYou from "../../components/ThankYou";

export default function THPropSell() {
  return (
    <div>
      <ThankYou />
    </div>
  );
}
